<template>
    <section class="space-section" id="team-section">
      <div style="margin-top:11%">
        <b-row class="justify-content-center">
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="title-sspace" data-aos="fade-up" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-center">
              <h5 class="text-center gotham-medium tm-title">{{ $t('team.title') }}</h5>
              <p class="text-center gotham-book tm-content">{{ $t('team.content') }}</p>
            </div>
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <!-- margin top 85px -->
            <div class="space-team">
              <b-row> 
                <b-col cols="12" class="web-view">
                  <div class="tm-fondo-img" data-aos="fade-left" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-center"></div>
                  <b-row align-h="center" data-aos="fade-down" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-center">
                    <b-col cols="10">
                      <b-row>
                        <b-col class="tm-card-space" cols="6" sm="6" md="3" lg="3" xl="3">
                          <div>
                            <card-comp 
                              :card-id="person1.cardId"
                              :card-key="person1.cardKey"
                              :src-img="person1.srcImg"
                              :c-name="person1.cName"
                              :c-area="person1.cArea"
                              :c-media="person1.cSMedia"
                              :class-icons="activeIcons"
                              :class-card="swipeCard"
                              @event="info">
                            </card-comp>
                          </div>
                        </b-col>
                        <b-col class="tm-card-space" cols="6" sm="6" md="3" lg="3" xl="3">
                          <div>
                            <card-comp 
                              :card-id="person2.cardId"
                              :card-key="person2.cardKey"
                              :src-img="person2.srcImg"
                              :c-name="person2.cName"
                              :c-area="person2.cArea"
                              :c-media="person2.cSMedia"
                              :class-icons="activeIcons2"
                              :class-card="swipeCard2"
                              @event="info">
                            </card-comp>
                          </div>
                        </b-col>
                        <b-col class="tm-card-space" cols="6" sm="6" md="3" lg="3" xl="3">
                          <div>
                            <card-comp 
                              :card-id="person3.cardId"
                              :card-key="person3.cardKey"
                              :src-img="person3.srcImg"
                              :c-name="person3.cName"
                              :c-area="person3.cArea"
                              :c-media="person3.cSMedia"
                              :class-icons="activeIcons3"
                              :class-card="swipeCard3"
                              @event="info">
                            </card-comp>
                          </div>
                        </b-col>
                        <b-col class="tm-card-space" cols="6" sm="6" md="3" lg="3" xl="3">
                          <div>
                            <card-comp 
                              :card-id="person4.cardId"
                              :card-key="person4.cardKey"
                              :src-img="person4.srcImg"
                              :c-name="person4.cName"
                              :c-area="person4.cArea"
                              :c-media="person4.cSMedia"
                              :class-icons="activeIcons4"
                              :class-card="swipeCard4"
                              @event="info">
                            </card-comp>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              
               
                <b-col cols="12" class="tablet-view panel-info1">
                  <div class="tm-fondo-img" data-aos="fade-left" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-center"></div>
                  <b-row data-aos="fade-down" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-center">
                    <b-col class="tm-card-space" cols="6" sm="6">
                      <div>
                        <card-comp 
                          card-id="card-5"
                          :card-key="5"
                          :src-img="person1.srcImg"
                          :c-name="person1.cName"
                          :c-area="person1.cArea"
                          :c-media="person1.cSMedia"
                          :class-icons="activeIcons"
                          :class-card="swipeCard"
                          @event="info">
                        </card-comp>
                      </div>
                    </b-col>
                    <b-col class="tm-card-space" cols="6" sm="6">
                      <div>
                        <card-comp 
                          card-id="card-6"
                          :card-key="6"
                          :src-img="person2.srcImg"
                          :c-name="person2.cName"
                          :c-area="person2.cArea"
                          :c-media="person2.cSMedia"
                          :class-icons="activeIcons2"
                          :class-card="swipeCard2"
                          @event="info">
                        </card-comp>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="tablet-view" cols="12">
                  <b-row class="justify-content-center">
                    <b-col :class="classGrid" class="txt-perfil">
                      <div :class="[card_animation, { active:isActive }]" class="info-styles" id="team-info">
                        <tm-card-info :card-info-head="dataCardHead" :card-info="dataCard" :card-activation="cardActivation"></tm-card-info>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" class="tablet-view panel-info2">
                  <div class="tm-fondo-img" data-aos="fade-left" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-center"></div>
                  <b-row data-aos="fade-down" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-center">
                    <b-col class="tm-card-space" cols="6" sm="6" md="3" lg="3" xl="3">
                      <div>
                        <card-comp 
                          card-id="card-7"
                          :card-key="7"
                          :src-img="person3.srcImg"
                          :c-name="person3.cName"
                          :c-area="person3.cArea"
                          :c-media="person3.cSMedia"
                          :class-icons="activeIcons3"
                          :class-card="swipeCard3"
                          @event="info">
                        </card-comp>
                      </div>
                    </b-col>
                    <b-col class="tm-card-space" cols="6" sm="6" md="3" lg="3" xl="3">
                      <div>
                        <card-comp 
                          card-id="card-8"
                          :card-key="8"
                          :src-img="person4.srcImg"
                          :c-name="person4.cName"
                          :c-area="person4.cArea"
                          :c-media="person4.cSMedia"
                          :class-icons="activeIcons4"
                          :class-card="swipeCard4"
                          @event="info">
                        </card-comp>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="tablet-view" :class="panel3" cols="12">
                  <b-row class="justify-content-center">
                    <b-col :class="classGrid2" class="txt-perfil">
                      <div :class="[card_animation2, { active:isActive2 }]" class="info-styles" id="team-info3">
                        <tm-card-info :card-info-head="dataCardHead2" :card-info="dataCard2" :card-activation="cardActivation2"></tm-card-info>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="web-view justify-content-center" :class="panel3">
                <b-col :class="classGrid">
                  <div :class="[card_animation, { active:isActive }]" class="info-styles" id="team-info">
                    <tm-card-info :card-info-head="dataCardHead" :card-info="dataCard" :card-activation="cardActivation"></tm-card-info>
                  </div>
                </b-col>
              </b-row>

              <b-row class="justify-content-center">
                <b-col cols="12" class="text-center tm-panel-contact" id="section-contact">
                  <div class="tm-fondo-contact" data-aos="fade-up-left" data-aos-once="true" data-aos-duration="1000" data-aos-id="super-duper" data-aos-anchor-placement="top-bottom" data-aos-offset="500"></div>
                  <div id="fondo-id" class="tm-centrar" data-aos="fade-up" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-center">
                    <div class="margin-blue">
                      <span class="tm-title-contact gotham-bold">{{ $t("team.proyect") }}</span>
                    </div>
                    <div class="margin-btn">
                      <button class="btn-contact gotham-medium" onclick="window.open('https://wa.me/5215540397847')">{{ $t("team.whatsapp") }}</button>
                      <button class="btn-contact gotham-medium" onclick="location.href='#contact-section'">{{ $t("team.email") }}</button>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
    </section>
</template>

<style>
.tablet-view{
  display: none;
}

.gotham-bold{
  font-family: "Gotham Bold Regular";
}

.gotham-book{
  font-family: "Gotham Book Regular";
}

.gotham-light{
  font-family: "Gotham light Regular";
}

.gotham-medium{
  font-family: "Gotham Medium Regular";
}

.tm-title{
  color: #1D2B3C;
  font-size: 32px;
  margin-bottom: 3.4%;
  letter-spacing: 2.46px; 
  line-height: 36px;
  /* margin bottom → 54px */
}

/* .txt-perfil{
  margin-top: 5%;
} */
.space-team{
  margin-top: 4.5%;;
}

.panel-info1{
  margin-bottom: 8%;
}

.panel-info2{
  margin-top: 8%;
}

.panel3{
  margin-top: 4%;
  margin-bottom: 4%;
}

.tm-content{
  font-size: 20px;
  color: #1D1D1D;
  margin: 0 18%;
  letter-spacing: 1.54px;
  line-height: 28px;
  /* margin left y margin right → 260px */
}

.tm-fondo-img{
  background-image: linear-gradient(
      rgba(29, 43, 60, 0.4),
      rgba(29, 43, 60, 0.4)
    ), url("../assets/img/fondo-teamx2.jpg");
  background-position: center 11.5rem;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  position: absolute;
  height: 100%;
  width: 100%;
}

/* .tm-card-space{
  padding-bottom: 30px;
} */

.tm-card{
  border: none !important;
  background-color: transparent !important;
  width: 100%;
  height: 100%;
  background-position: center;
  -webkit-transition: transform 0.5s ease 0s;
  transition: transform 0.5s ease 0s;
}

.tm-card .card-body{
  padding: 0;
}

.tm-person-name{
  background-color: #04182E;
  color: #FFFFFF;
  font-family: "Gotham Medium Regular";
  padding: 16px 0;
  cursor: pointer;
}

.tm-card img{
  width: 330px;
	height: 330px;
	object-fit: cover;
  cursor: pointer;
} 

.tm-person-name span{
  font-size: 25px;
  line-height: 2;
}

.tm-card .tm-person-area{
  color: #FFFFFF;
  font-family: "Gotham Book Regular";
  font-size: 25px;
}

.tm-card-hover1:hover, .tm-card-hover2:hover, .tm-card-hover3:hover, .tm-card-hover4:hover{
  -webkit-transform: translateY(20px);
  transform: translateY(20px);
}

.tm-icons-content svg, .tm-icons-content2 svg, .tm-icons-content3 svg, .tm-icons-content4 svg{
  visibility: hidden;
}

#icons, #icons2, #icons3, #icons4{
  margin-top: 27px;
}

#icons svg, #icons2 svg, #icons3 svg, #icons4 svg{
  cursor: pointer;
  /* margin-right: 7px; */
  /* margin-left: 7px; */
  margin-top: 2px;
  /* width: 40px;
  height: 40px; */
}

#icons a:link, #icons a:visited, #icons a:hover, #icons a:active, #icons2 a:link, #icons2 a:visited, #icons2 a:hover, #icons2 a:active, #icons3 a:link, #icons3 a:visited, #icons3 a:hover, #icons3 a:active, #icons4 a:link, #icons4 a:visited, #icons4 a:hover, #icons4 a:active{
  color: #ffffff;
}

.animate-card, .animate-card4{
  transform: translateY(-50px);
}

.animate-card2, .animate-card3{
  transform: translateY(-50px);
}

/* .animate-card .tm-person-area, .animate-card2 .tm-person-area, .animate-card3 .tm-person-area, .animate-card4 .tm-person-area{
  color: #04182E;
} */

.info-styles span{
  color: #1D1D1D;
  font-family: "Gotham Medium Regular";
  font-size: 20px;
  letter-spacing: 1.54px;
  line-height: 28px;
}

.info-styles p{
  color: #1D1D1D;
  font-family: "Gotham Book Regular";
  font-size: 20px;
  margin: 0 0 0 0;
  letter-spacing: 1.54px;
  line-height: 28px;
}

.tm-panel-contact{
  display: table;
  height: 100vh;
  /* margin-top: 3%; */
}

.tm-fondo-contact{
  background-color: #2ABECC;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: -1;
}

.tm-centrar{
  display: table-cell;
	vertical-align: middle;
}

.tm-title-contact{
  color: #1D2B3C;
  font-size: 45px;
  letter-spacing: 3.46px;
  line-height: 52px;
}

.btn-contact:hover{
  color: #FFF;
  background-position: -100% 0 !important;
}

.btn-contact{
  background: transparent !important;
  border: 2px solid #04182E !important;
  border-radius: 0% !important;
  color: #04182E;
  font-size: 20px;
  margin: 4% 2% 4% 2%;
  text-decoration: none;
  width: 350px;
  height: 70px;
  background-size: 200% 100% !important;
  background-image: linear-gradient(to right, transparent 50%, #04182E 50%) !important;
  -webkit-transition: background-position 1s;
  -moz-transition: background-position 1s;
  transition: background-position 1s;
}

.change-color .btn-contact:hover{
  color:#04182E;
}

.change-hover .btn-contact{
  background-image: linear-gradient(to right, transparent 50%, #FFF 50%) !important;
}


.change-color .tm-title-contact, .change-color .btn-contact{
  color: #FFFFFF;
}
.change-color .btn-contact{
  color: #FFFFFF;
  border: 2px solid #FFF !important;
}

@media (max-width: 1840px){
  .tm-card img{
    width: 295px;
    height: 295px;
  }
}

@media (max-width: 1800px){
  .tm-title{
    font-size: 20px;
    letter-spacing: 1.54px;
    line-height: 28px;
  }
  .tm-content{
    font-size: 16px;
    letter-spacing: 1.23px;
    line-height: 25px;
  }
  .tm-title-contact{
    font-size: 28px;
    letter-spacing: 2.16px;
    line-height: 40px;
  } 
  .info-styles span, .info-styles p{
    font-size: 16px;
    letter-spacing: 1.23px;
    line-height: 25px;
  }
  .tm-person-name span{
    font-size: 22px;
  }
  .tm-card .tm-person-area{
    font-size: 22px;
  }
}

@media (max-width: 1704px) {
  .tm-fondo-img{
    background-position: center 10rem;
  }
  /* .tm-card-space{
    padding-bottom: 10px;
  }  */
  .tm-card img{
    width: 270px;
    height: 270px;
  }
  .tm-person-name span{
    font-size: 20px;
  }
  .tm-card .tm-person-area{
    font-size: 20px;
  }
  .tm-person-name{
    padding: 14px 0;
  }
}

@media (max-width: 1540px) {
  .tm-fondo-img{
    background-position: center 8rem;
  }
  .tm-card img{
    width: 250px;
    height: 250px;
  }
  .tm-person-name span{
    font-size: 18px;
  }
  .tm-card .tm-person-area{
    font-size: 18px;
  }
  .tm-person-name{
    padding: 12px 0;
  }
  .btn-contact{
    height: 55px;
  }
}

@media (max-width: 1430px) {
  .tm-content{
    margin: 0 10%;
  }
  .tm-fondo-img{
    background-position: center 7rem;
  }
  .tm-person-name span, .tm-card .tm-person-area{
    font-size: 18px;
  }  
  .animate-card, .animate-card4{
    transform: translateY(-50px);
  }
  .animate-card2, .animate-card3{
    transform: translateY(-50px);
  }
  .tm-card img{
    width: 230px;
    height: 230px;
  }
}

@media (max-width: 1360px) {
  .tm-card img{
    width: 205px;
    height: 205px;
  }
  .space-team{
    margin-top: 5.5%;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (max-width: 1200px) { 
  .tm-fondo-img{
    background-position: center 6rem;
  }
  .tm-card img{
    width: 170px;
    height: 170px;
  }
  .tm-card .tm-person-area{
    font-size: 16px;
  }
  .tm-person-name span{
    font-size: 14px;
  }
  #icons svg, #icons2 svg, #icons3 svg, #icons4 svg{
    width: 28px;
    height: 28px;
  }
  .animate-card, .animate-card4{
    transform: translateY(-50px);
  }
  .animate-card2, .animate-card3{
    transform: translateY(-50px);
  }
  .info-styles span, .info-styles p{
    font-size: 16px;
  }
  .btn-contact{
    font-size: 16px !important;
  }
  .space-team{
    margin-top: 6%;
  }
}



@media (max-width: 1024px) { 
  .tm-fondo-img{
    background-position: center 5.5rem;
  }
  .tm-person-name span, .tm-card .tm-person-area{
    font-size: 12.5px;
  }
  .tm-card img{
    width: 150px;
    height: 150px;
  }
  .space-team{
    margin-top: 7%;
  }
}

@media (max-width: 960px){
  .tm-title{
    font-size: 18px;
    letter-spacing: 1.39px;
    line-height: 26px;
  }
  .tm-content{
    font-size: 15px;
    letter-spacing: 1.16px;
    line-height: 23px;
  }
  .tm-title-contact{
    font-size: 18px;
    letter-spacing: 1.39px;
    line-height: 28px;
  }
  .info-styles span, .info-styles p{
    font-size: 15px;
    letter-spacing: 1.16px;
    line-height: 23px;
  } 
  .space-team{
    margin-top: 8%;
  }
}

@media (max-width: 900px) { 
  .tm-card img{
    width: 130px;
    height: 130px;
  }
  .tm-fondo-img{
    background-position: center 5rem;
  }
  .tm-person-name span{
    font-size: 11px;
  }  
  .tm-card .tm-person-area{
    font-size: 14px;
  }
}

@media (max-width: 800px) { 
  .tm-fondo-img{
    background-position: center 4.7rem;
  }
  .tm-card img{
    width: 110px;
    height: 110px;
  } 
  .tm-card .tm-person-area{
    font-size: 13px;
  }
  .space-team{
    margin-top: 9%;
  }
}

@media (max-width: 767px){
  .tablet-view{
    display: block;
  }
  .web-view{
    display: none !important;
  }
  .tm-fondo-img{
    background-position: center 7.7rem;
  }
  .tm-card img{
    width: 220px;
    height: 220px;
  }
  .animate-card, .animate-card2, .animate-card2, .animate-card3{
    transform: translateY(-40px);
  }
  .info-styles p{
    margin: 0 0 0 0;
  }
  .title-sspace{
    margin-bottom: 5%;
  }
  /* .txt-perfil{
    margin-top: 10%;
  } */
  .panel3{
    margin-top: 8%;
    margin-bottom: 8%;
  }
  .margin-btn{
    margin-top: 5%;
  }
  .margin-blue{
    margin: 0 7% 0 7%;
  }
  .tm-person-name{
    margin: 0 5%;
  }
  .btn-contact{
    font-size: 14px !important;
    width: 250px;
  }
}

@media (max-width: 575px){
  .tm-card img{
    width: 160px;
    height: 160px;
  }
  .animate-card, .animate-card2, .animate-card2, .animate-card3{
    transform: translateY(-40px);
  }
  .btn-contact{
    height: 50px;
  }
  .info-styles div{
    margin-right: 7%;
    margin-left: 7%;
  }
  .tm-person-name{
    margin: 0 6%;
  }
}

@media (max-width: 430px){
  .tm-card img{
    width: 146px;
    height: 146px;
  }
  .tm-fondo-img{
    background-position: center 5rem;
  }
  .animate-card, .animate-card2, .animate-card2, .animate-card3{
    transform: translateY(-30px);
  }
}
</style>

<script>
import TmCardInfo from './TmCardInfo'
import CardComp from './CardComponent'

export default {
  name: 'Team',
  components: {
    TmCardInfo,
    CardComp
  },
  data(){
    return{
      person1: {
        cardId: "card-1",
        cardKey: 1,
        srcImg: "mariana1.jpg",
        cName: "MARIANA PINET",
        cArea: "CEO & Creative \n Director",
        cSMedia: "https://www.linkedin.com/in/marianapinet/?originalSubdomain=mx"
      },
      person2: {
        cardId: "card-2",
        cardKey: 2,
        srcImg: "daniRx2.jpg",
        cName: "DANIELA RODRÍGUEZ",
        cArea: "Art Director \n Branding & Storytelling",
        cSMedia: "https://www.instagram.com/danirdzj/"
      },
      person3: {
        cardId: "card-3",
        cardKey: 3,
        srcImg: "rossanax2.jpg",
        cName: "ROSSANA VIZCAINO",
        cArea: "Junior Designer \n Branding & Storytelling",
        cSMedia: "https://www.linkedin.com/in/rossana-vizcaino-trani-113541104/"
      },
      person4: {
        cardId: "card-4",
        cardKey: 4,
        srcImg: "daniMx2.jpg",
        cName: "DANIELA MARÍN",
        cArea: "Art Director \n Motion Graphics & \n Community Management",
        cSMedia: "https://www.linkedin.com/in/daniela-mar%C3%ADn-avelar-bb335b1aa/"
      },
      panel3: "",
      cardActivation: 0,
      cardActivation2: 0,
      swipeCard: "tm-card-hover1",
      swipeCard2: "tm-card-hover2",
      swipeCard3: "tm-card-hover3",
      swipeCard4: "tm-card-hover4",
      activeIcons: "tm-icons-content",
      activeIcons2: "tm-icons-content2",
      activeIcons3: "tm-icons-content3",
      activeIcons4: "tm-icons-content4",
      classGrid: "",
      card_animation: "",
      isActive: false,
      dataCardHead: "",
      dataCard: "",
      classGrid2: "",
      card_animation2: "",
      isActive2: false,
      dataCardHead2: "",
      dataCard2: ""
    }
  },
  methods: {
    info(data){
      var self = this;
      
      if(data === 1){
        let cardElement = document.getElementById("card-1");
        let web = true;

        if(this.isActive){
          if(this.cardActivation === 2){
            this.restart2("",self);
            this.active1("",web);
          }else if(this.cardActivation === 3){
            this.restart3("",self,web);
            this.active1("",web);
          }else if(this.cardActivation === 4){
            this.restart4("",self,web);
            this.active1("",web);
          }else{
            this.restart1(cardElement,self);
          }
        }else{
          this.active1(cardElement,web);     
        }
      }
      if(data == 2){
        let cardElement = document.getElementById("card-2");
        let web = true;

        if(this.isActive){
          if(this.cardActivation === 1){
            this.restart1("",self);
            this.active2("",web);
          }else if(this.cardActivation === 3){
            this.restart3("",self,web);
            this.active2("",web);
          }else if(this.cardActivation === 4){
            this.restart4("",self,web);
            this.active2("",web);
          }else{
            this.restart2(cardElement,self);
          }
        }else{
          this.active2(cardElement,web);   
        }
      }
      if(data == 3){
        let cardElement = document.getElementById("card-3");
        let web = true;

        if(this.isActive){
          if(this.cardActivation === 1){
            this.restart1("",self);
            this.active3("",web);
          }else if(this.cardActivation === 2){
            this.restart2("",self);
            this.active3("",web);
          }else if(this.cardActivation === 4){
            this.restart4("",self,web);
            this.active3("",web);
          }else{
            this.restart3(cardElement,self,web);
          }
        }else{
          this.active3(cardElement,web);     
        }
      }
      if(data == 4){
        let cardElement = document.getElementById("card-4");
        let web = true;

        if(this.isActive){
          if(this.cardActivation === 1){
            this.restart1("",self);
            this.active4("",web);
          }else if(this.cardActivation === 2){
            this.restart2("",self);
            this.active4("",web);
          }else if(this.cardActivation === 3){
            this.restart3("",self,web);
            this.active4("",web);
          }else{
            this.restart4(cardElement,self,web);
          }
        }else{
          this.active4(cardElement,web);     
        }
      }
      if(data === 5){
        let cardElement = document.getElementById("card-5");
        let web = false;
        console.log(this.isActive)
        console.log(this.isActive2)
        console.log(this.cardActivation);
        console.log(this.cardActivation2);

        if(this.isActive || this.isActive2 ){
          if(this.cardActivation === 2){
            this.restart2("",self);
            this.active1("",web);
          }else if(this.cardActivation2 === 3){
            this.restart3("",self,web);
            this.active1("",web);
          }else if(this.cardActivation2 === 4){
            this.restart4("",self,web);
            this.active1("",web);
          }else{
            this.restart1(cardElement,self);
          }
        }else{
          this.active1(cardElement,web);     
        }
      }
      if(data === 6){
        let cardElement = document.getElementById("card-6");
        let web = false;
        console.log(this.isActive)
        if(this.isActive || this.isActive2 ){
          if(this.cardActivation === 1){
            this.restart1("",self);
            this.active2("",web);
          }else if(this.cardActivation2 === 3){
            this.restart3("",self,web);
            this.active2("",web);
          }else if(this.cardActivation2 === 4){
            this.restart4("",self,web);
            this.active2("",web);
          }else{
            this.restart2(cardElement,self);
          }
        }else{
          this.active2(cardElement,web);   
        }
      }
      if(data == 7){
        let cardElement = document.getElementById("card-7");
        let web = false;

        console.log(this.isActive);
        console.log(this.isActive2);
        console.log(this.cardActivation);
        console.log(this.cardActivation2);

        if(this.isActive2 || this.isActive){
          if(this.cardActivation === 1){
            this.restart1("",self);
            this.active3("",web);
          }else if(this.cardActivation === 2){
            this.restart2("",self);
            this.active3("",web);
          }else if(this.cardActivation2 === 4){
            this.restart4("",self,web);
            this.active3("",web);
          }else{
            this.restart3(cardElement,self,web);
          }
        }else{
          this.active3(cardElement,web);     
        }
      }
      if(data == 8){
        let cardElement = document.getElementById("card-8");
        let web = false;

        if(this.isActive2 || this.isActive){
          if(this.cardActivation === 1){
            this.restart1("",self);
            this.active4("",web);
          }else if(this.cardActivation === 2){
            this.restart2("",self);
            this.active4("",web);
          }else if(this.cardActivation2 === 3){
            this.restart3("",self,web);
            this.active4("",web);
          }
          else{
            this.restart4(cardElement,self,web);
          }
        }else{
          this.active4(cardElement,web);     
        }
      }
    },
    restartData(){
      this.dataCardHead = "";
      this.dataCard = "";
    },
    restartData2(){
      this.dataCardHead2 = "";
      this.dataCard2 = "";
    },
    restart1(val,self){
      this.cardActivation = 0;
      this.isActive = false;
      this.swipeCard = "tm-card-hover1";
      this.card_animation = "animate__animated animate__zoomOut";
      this.activeIcons = "tm-icons-content";
      this.panel3 = "";

      document.getElementById("icons").classList.remove("animate__animated","animate__fadeInDown");

      if(val != ""){
        // val.scrollIntoView({block: 'end'});
        setTimeout(function(){ self.restartData() }, 500); 
      }else{
        this.restartData();
      }
    },
    restart2(val,self){
      this.cardActivation = 0;
      this.isActive = false;
      this.swipeCard2= "tm-card-hover2";
      this.card_animation = "animate__animated animate__zoomOut";
      this.activeIcons2 = "tm-icons-content2";
      this.panel3 = "";

      document.getElementById("icons2").classList.remove("animate__animated","animate__fadeInDown");
      
      if(val != ""){
        // val.scrollIntoView({block: 'end'});
        setTimeout(function(){ self.restartData() }, 500); 
      }else{
        this.restartData();
      }
    },
    restart3(val,self,web){
      if(web){
        this.isActive = false;
        this.cardActivation = 0;
        this.card_animation = "animate__animated animate__zoomOut";
        this.panel3 = "";
      }else{
        this.isActive2 = false;
        this.cardActivation2 = 0;
        this.card_animation2 = "animate__animated animate__zoomOut";
        this.panel3 = "";
      }

      this.swipeCard3= "tm-card-hover3";
      this.activeIcons3 = "tm-icons-content3";
      
      document.getElementById("icons3").classList.remove("animate__animated","animate__fadeInDown");
      
      if(val != ""){
        // val.scrollIntoView({block: 'end'});
        setTimeout(function(){ ( (web) ? self.restartData() : self.restartData2() ) }, 500); 
      }else{
        ( (web) ? this.restartData() : this.restartData2() )
      }
    },
    restart4(val,self,web){
      if(web){
        this.isActive = false;
        this.cardActivation = 0;
        this.card_animation = "animate__animated animate__zoomOut";
        this.panel3 = "";
      }else{
        this.isActive2 = false;
        this.cardActivation2 = 0;
        this.card_animation2 = "animate__animated animate__zoomOut";
        this.panel3 = "";
      }      

      this.swipeCard4= "tm-card-hover4";
      this.activeIcons4 = "tm-icons-content4";
      
      document.getElementById("icons4").classList.remove("animate__animated","animate__fadeInDown");
      
      if(val != ""){
        // val.scrollIntoView({block: 'end'});
        setTimeout(function(){ ( (web) ? self.restartData() : self.restartData2() ) }, 500); 

      }else{
        ( (web) ? this.restartData() : this.restartData2() )
      }
    },
    active1(val,web){
      this.cardActivation = 1;
      this.isActive = true;
      this.swipeCard = "animate-card";      
      this.card_animation = "animate__animated animate__zoomIn";
      this.activeIcons = "animate__animated animate__fadeInDown";

      if(web){
        this.classGrid = "col-md-8 col-lg-8 col-xl-9";
        this.panel3 = "panel3";
      }else{
        this.classGrid = "col-12 col-sm-10";
      }
      
      this.dataCardHead = "team.info_person_head";
      this.dataCard = "team.info_person";

      if(val != ""){
        // val.scrollIntoView({block: 'start'});
      }
    },
    active2(val,web){
      this.cardActivation = 2;
      this.isActive = true;
      this.swipeCard2 = "animate-card2";
      this.card_animation = "animate__animated animate__zoomIn";
      this.activeIcons2 = "animate__animated animate__fadeInDown";  
      
      if(web){
        this.classGrid = "col-md-8 col-lg-8 col-xl-9";
        this.panel3 = "panel3";
      }else{
        this.classGrid = "col-12 col-sm-10";
      }
      
      this.dataCardHead = "team.info_person_head2";
      this.dataCard = "team.info_person2";

      if(val != ""){
        // val.scrollIntoView({block: 'start'});
      }
    },
    active3(val,web){
      this.swipeCard3 = "animate-card3";
      this.activeIcons3 = "animate__animated animate__fadeInDown";  

      if(web){
        this.cardActivation = 3;
        this.isActive = true;
        this.card_animation = "animate__animated animate__zoomIn";
        this.classGrid = "col-md-8 col-lg-8 col-xl-9";
        this.dataCardHead = "team.info_person_head3";
        this.dataCard = "team.info_person3";
        this.panel3 = "panel3";
      }else{
        this.cardActivation2 = 3;
        this.isActive2 = true;
        this.card_animation2 = "animate__animated animate__zoomIn";
        this.classGrid2 = "col-12 col-sm-10";
        this.dataCardHead2 = "team.info_person_head3";
        this.dataCard2 = "team.info_person3";
        this.panel3 = "panel3";
      }

      if(val != ""){
        // val.scrollIntoView({block: 'start'});
      }
    },
    active4(val,web){
      this.swipeCard4 = "animate-card4";
      this.activeIcons4 = "animate__animated animate__fadeInDown";  

      if(web){
        this.cardActivation = 4;
        this.isActive = true;
        this.card_animation = "animate__animated animate__zoomIn";
        this.classGrid = "col-md-8 col-lg-8 col-xl-9";
        this.dataCardHead = "team.info_person_head4";
        this.dataCard = "team.info_person4";
        this.panel3 = "panel3";
      }else{
        this.cardActivation2 = 4;
        this.isActive2 = true;
        this.card_animation2 = "animate__animated animate__zoomIn";
        this.classGrid2 = "col-12 col-sm-10";
        this.dataCardHead2 = "team.info_person_head4";
        this.dataCard2 = "team.info_person4";
        this.panel3 = "panel3";
      }

      if(val != ""){
        // val.scrollIntoView({block: 'start'});
      }
    }
  },
  mounted: function(){
    document.addEventListener('aos:in:super-duper', ({ detail }) => {
      console.log(detail.classList);
      let changeColor = document.getElementById("fondo-id");
      changeColor.classList.add("change-color", "change-hover");
    }); 
  }
}
</script>